module.exports = __webpack_public_path__ + "img/kuchynka_2.1b3e99c6.jpg";